import { useSelector } from 'react-redux'
import { MarketState, State } from '../types'

export const useMarketData = (): MarketState => {
  return useSelector((state: State) => state.market)
}
